import { render, staticRenderFns } from "./ConversationDetailsPanel.vue?vue&type=template&id=2e1b4ec4&scoped=true"
import script from "./ConversationDetailsPanel.vue?vue&type=script&lang=js"
export * from "./ConversationDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./ConversationDetailsPanel.vue?vue&type=style&index=0&id=2e1b4ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b4ec4",
  null
  
)

export default component.exports